/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StateViewModel } from "../types/StateViewModel.ts";

export const stateViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  code: z.string().nullish(),
  name: z.string().nullish(),
  abbreviation: z.string().nullish(),
  countryId: z.optional(z.number().int()),
  countryName: z.string().nullish(),
}) as unknown as ToZod<StateViewModel>;
